import store from "@/state/store";

export default [
  {
    path: process.env.VUE_APP_DB_URI + "/login",
    name: "login",
    component: () => import('../views/auth/signin/cover'),
    meta: {
      title: "Login",
    },
  },
  // {
  //   path: process.env.VUE_APP_DB_URI + "/register",
  //   name: "Register",
  //   component: () => import("../views/account/register.vue"),
  //   meta: {
  //     title: "Register",
  //     beforeResolve(routeTo, routeFrom, next) {
  //       // If the user is already logged in
  //       if (store.getters["auth/loggedIn"]) {
  //         // Redirect to the home page instead
  //         next({ name: "dashboard" });
  //       } else {
  //         // Continue to the login page
  //         next();
  //       }
  //     },
  //   },
  // },
  // {
  //   path: process.env.VUE_APP_DB_URI + "/reset-pwd-cover",
  //   name: "Reset password",
  //   component: () => import("../views/auth/reset/cover"),
  //   meta: {
  //     title: "Forgot Password",
  //   },
  // },
  {
    path: process.env.VUE_APP_DB_URI + "/resetPwd",
    name: "Forgot password",
    component: () => import("../views/auth/reset/cover"),
    meta: {
      title: "Forgot Password",
    },
  },
  {
    path: process.env.VUE_APP_DB_URI + "/activateOTP",
    name: "Activate Otp",
    component: () => import("../views/auth/otp/cover"),
    meta: {
      title: "Activate Otp",
    },
  },
  {
    path: process.env.VUE_APP_DB_URI + "/installation",
    name: "installation",
    component: () => import("../views/auth/installation/cover"),
    meta: {
      title: "Installation",
    },
  },
  {
    path: process.env.VUE_APP_DB_URI + "/action-alert-message",
    name: "alert-message",
    component: () => import("../views/auth/alert-message/cover"),
    meta: {
      title: "Alert Message",
    },
  },
  {
    path: process.env.VUE_APP_DB_URI + "/modify-password",
    name: "modify-password",
    component: () => import("../views/auth/modify/profile"),
    meta: {
      title: "Modify Password",
    },
  },

  {
    path: process.env.VUE_APP_DB_URI + "/",
    name: "dashboard",
    meta: {
      title: "Dashboard",
      authRequired: true,
    },
    component: () => import("../views/dashboard/index.vue"),
  },
  {
    path: process.env.VUE_APP_DB_URI + "/logout",
    name: "logout",
    meta: {
      title: "Logout", authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        localStorage.clear();
        sessionStorage.clear();
        next();
      },
    },
    component: () => import("../views/auth/logout/cover")
  },

  {
    path: process.env.VUE_APP_DB_URI + '/auth/404',
    name: '404',
    meta: {
      title: "Error 404", authRequired: true,
    },
    component: () => import('../views/auth/errors/404')
  },
  {
    path: process.env.VUE_APP_DB_URI + '/auth/500',
    name: '500',
    meta: {
      title: "Error 500", authRequired: true,
    },
    component: () => import('../views/auth/errors/500')
  },
  {
    path: process.env.VUE_APP_DB_URI + '/auth/404-cover',
    name: '404-cover',
    meta: {
      title: "Error 404", authRequired: true,
    },
    component: () => import('../views/auth/errors/404-cover')
  },
  {
    path: process.env.VUE_APP_DB_URI + '/auth/ofline',
    name: 'ofline',
    meta: {
      title: "Offline", authRequired: true,
    },
    component: () => import('../views/auth/errors/ofline')
  },
  {
    path: process.env.VUE_APP_DB_URI + '/auth/logout-cover',
    name: 'logout-cover',
    meta: {
      title: "Logout", authRequired: true,
    },
    component: () => import('../views/auth/logout/cover')
  },
  {
    path: process.env.VUE_APP_DB_URI + '/auth/success-msg-cover',
    name: 'success-msg-cover',
    meta: {
      title: "Success Message", authRequired: true,
    },
    component: () => import('../views/auth/success-msg/cover')
  },
  {
    path: process.env.VUE_APP_DB_URI + '/auth/lockscreen-cover',
    name: 'lock-screen-cover',
    meta: {
      title: "Lock Screen", authRequired: true,
    },
    component: () => import('../views/auth/lockscreen/cover')
  },


  {
    path: process.env.VUE_APP_DB_URI + "/device",
    name: "device",
    meta: { title: "device", authRequired: true },
    component: () => import("../views/device-mgmt/device/index"),
  },
  {
    path: process.env.VUE_APP_DB_URI + "/ecr-pos",
    name: "ecr-pos",
    meta: { title: "ECR POS", authRequired: true },
    component: () => import("../views/device-mgmt/ecrpos/index"),
  },
  {
    path: process.env.VUE_APP_DB_URI + "/device/detail/:id",
    name: "device-detail",
    meta: { title: "Device Details", authRequired: true },
    component: () => import("../views/device-mgmt/device/detail"),
  },
  {
    path: process.env.VUE_APP_DB_URI + "/partner",
    name: "partner",
    meta: { title: "Partner", authRequired: true },
    component: () => import("../views/partner/index.vue"),
  },
  {
    path: process.env.VUE_APP_DB_URI + "/customer",
    name: "customer",
    meta: { title: "Customer", authRequired: true },
    component: () => import("../views/partner/index.vue"),
  },
  {
    path: process.env.VUE_APP_DB_URI + "/merchant",
    name: "merchant",
    meta: { title: "Merchant", authRequired: true },
    component: () => import("../views/partner/index.vue"),
  },
  {
    path: process.env.VUE_APP_DB_URI + "/firmware",
    name: "firmware",
    meta: { title: "Firmware", authRequired: true },
    component: () => import("../views/firmware/index.vue"),
  },
  {
    path: process.env.VUE_APP_DB_URI + "/wallpaper",
    name: "wallpaper",
    meta: { title: "Wallpaper", authRequired: true },
    component: () => import("../views/device-mgmt/ui/wallpaper/index.vue"),
  },
  {
    path: process.env.VUE_APP_DB_URI + "/boot-picture",
    name: "boot-picture",
    meta: { title: "Boot Picture", authRequired: true },
    component: () => import("../views/device-mgmt/ui/boot-picture/index.vue"),
  },
  {
    path: process.env.VUE_APP_DB_URI + "/boot-animation",
    name: "boot-animation",
    meta: { title: "Boot Animation", authRequired: true },
    component: () => import("../views/device-mgmt/ui/boot-animation/index.vue"),
  },
  {
    path: process.env.VUE_APP_DB_URI + "/hardware",
    name: "hardware-parameter",
    meta: { title: "Hardware", authRequired: true },
    component: () => import("../views/device-mgmt/settings/hardware/index.vue"),
  },
  {
    path: process.env.VUE_APP_DB_URI + "/general",
    name: "general-parameter",
    meta: { title: "General", authRequired: true },
    component: () => import("../views/device-mgmt/settings/general/index.vue"),
  },
  {
    path: process.env.VUE_APP_DB_URI + "/terminal-profiles",
    name: "terminal-profiles",
    meta: { title: "Terminal Profiles", authRequired: true },
    component: () => import("../views/device-mgmt/profiles/index.vue"),
  },
  {
    path: process.env.VUE_APP_DB_URI + "/geo-fence",
    name: "geo-fence",
    meta: { title: "Geo Fencing", authRequired: true },
    component: () => import("../views/device-mgmt/geo-fence/index.vue"),
  },
  {
    path: process.env.VUE_APP_DB_URI + "/product-model",
    name: "product-model",
    meta: { title: "Product Model", authRequired: true },
    component: () => import("../views/device-mgmt/model/index.vue"),
  },
  {
    path: process.env.VUE_APP_DB_URI + "/log-capture",
    name: "log-capture",
    meta: { title: "Log Capture", authRequired: true },
    component: () => import("../views/device-mgmt/log-capture/index.vue"),
  },
  {
    path: process.env.VUE_APP_DB_URI + "/group",
    name: "group",
    meta: { title: "Group", authRequired: true },
    component: () => import("../views/device-mgmt/group/index.vue"),
  },
  {
    path: process.env.VUE_APP_DB_URI + "/device-extend-attribute",
    name: "device-extend-attribute",
    meta: { title: "Device Extend Attribute", authRequired: true },
    component: () => import("../views/device-mgmt/attr/index.vue"),
  },
  {
    path: process.env.VUE_APP_DB_URI + "/device-lifecycle",
    name: "device-life-cycle",
    meta: { title: "Device Life Cycle", authRequired: true },
    component: () => import("../views/device-mgmt/cycle/index.vue"),
  },


  {
    path: process.env.VUE_APP_DB_URI + "/transaction-param",
    name: "transaction-param",
    meta: { title: "Transaction Param", authRequired: true },
    component: () => import("../views/transaction/transaction/index.vue"),
  },
  {
    path: process.env.VUE_APP_DB_URI + "/cloud-message",
    name: "cloud-message",
    meta: { title: "Cloud Message", authRequired: true },
    component: () => import("../views/transaction/cloud-message/index.vue"),
  },
  {
    path: process.env.VUE_APP_DB_URI + "/tids",
    name: "tid",
    meta: { title: "Tid", authRequired: true },
    component: () => import("../views/transaction/tid/index.vue"),
  },

  {
    path: process.env.VUE_APP_DB_URI + "/application",
    name: "application",
    meta: { title: "Application", authRequired: true },
    component: () => import("../views/application/application/index.vue"),
  },
  {
    path: process.env.VUE_APP_DB_URI + "/certificates",
    name: "certificates",
    meta: { title: "Application certificates", authRequired: true },
    component: () => import("../views/application/certificate"),
  },
  {
    path: process.env.VUE_APP_DB_URI + "/push-report",
    name: "push-report",
    meta: { title: "Push Report", authRequired: true },
    component: () => import("../views/push/push-report/index.vue"),
  },
  {
    path: process.env.VUE_APP_DB_URI + "/calendar",
    name: "calendar",
    meta: { title: "Scheduler", authRequired: true },
    component: () => import("../views/push/push-report/calendar.vue"),
  },
  {
    path: process.env.VUE_APP_DB_URI + "/scheduler-tasks",
    name: "scheduler-tasks",
    meta: { title: "Scheduler Tasks", authRequired: true },
    component: () => import("../views/push/scheduler/index.vue"),
  },
  {
    path: process.env.VUE_APP_DB_URI + "/message",
    name: "message",
    meta: { title: "Message", authRequired: true },
    component: () => import("../views/push/message/index.vue"),
  },
  {
    path: process.env.VUE_APP_DB_URI + "/advertisement-file",
    name: "advertisement-file",
    meta: { title: "File", authRequired: true },
    component: () => import("../views/push/advertisement/file/index.vue"),
  },
  {
    path: process.env.VUE_APP_DB_URI + "/advertisement-planner",
    name: "advertisement-planner",
    meta: { title: "Advertisement", authRequired: true },
    component: () => import("../views/push/advertisement/planner/index.vue"),
  },
  {
    path: process.env.VUE_APP_DB_URI + "/tls-certificates",
    name: "tls-certificates",
    meta: { title: "TLS Certificates", authRequired: true },
    component: () => import("../views/push/certificates/index.vue"),
  },

  // {
  //   path: process.env.VUE_APP_DB_URI + "/key-capture",
  //   name: "key-capture",
  //   meta: { title: "Capture", authRequired: true },
  //   component: () => import("../views/rki/create-capture.vue"),
  // },
  {
    path: process.env.VUE_APP_DB_URI + "/key-capture-report",
    name: "key-capture-report",
    meta: { title: "Capture Report", authRequired: true },
    component: () => import("../views/rki/capture-report/index.vue"),
  },
  {
    path: process.env.VUE_APP_DB_URI + "/export-device-public-key",
    name: "export-device-public-key",
    meta: { title: "Export Device Public Key", authRequired: true },
    component: () => import("../views/rki/capture-report/export-device-public-key.vue"),
  },
  {
    path: process.env.VUE_APP_DB_URI + "/hsm",
    name: "hsm",
    meta: { title: "Hsm", authRequired: true },
    component: () => import("../views/rki/hsm/index.vue"),
  },

  {
    path: process.env.VUE_APP_DB_URI + "/partner-settings",
    name: "partner-settings",
    meta: { title: "Partner Settings", authRequired: true },
    component: () => import("../views/settings/partner/index.vue"),
  },
  {
    path: process.env.VUE_APP_DB_URI + "/email-settings",
    name: "email-settings",
    meta: { title: "Email Settings", authRequired: true },
    component: () => import("../views/settings/email/index.vue"),
  },
  {
    path: process.env.VUE_APP_DB_URI + "/sms-settings",
    name: "sms-settings",
    meta: { title: "SMS Settings", authRequired: true },
    component: () => import("../views/settings/sms/index.vue"),
  },
  {
    path: process.env.VUE_APP_DB_URI + "/password-policy",
    name: "password-configuration",
    meta: { title: "Password Configuration", authRequired: true },
    component: () => import("../views/settings/password/index.vue"),
  },
  {
    path: process.env.VUE_APP_DB_URI + "/task-scheduler",
    name: "task-scheduler",
    meta: { title: "Task Scheduler", authRequired: true },
    component: () => import("../views/settings/task/index.vue"),
  },
  {
    path: process.env.VUE_APP_DB_URI + "/task-scheduler-logs",
    name: "task-scheduler-logs",
    meta: { title: "Task Scheduler Logs", authRequired: true },
    component: () => import("../views/settings/task/logs.vue"),
  },
  {
    path: process.env.VUE_APP_DB_URI + "/notice-list",
    name: "policies",
    meta: { title: "Policies", authRequired: true },
    component: () => import("../views/notice/settings/index.vue"),
  },
  {
    path: process.env.VUE_APP_DB_URI + "/alert-logs",
    name: "logs",
    meta: { title: "Alert Logs", authRequired: true },
    component: () => import("../views/notice/logs.vue"),
  },
  // {
  //   path: process.env.VUE_APP_DB_URI + "/alert-policy",
  //   name: "alert-policy",
  //   meta: { title: "Alarm Policies", authRequired: true },
  //   component: () => import("../views/notice/policy/policies/index.vue"),
  // },
  // {
  //   path: process.env.VUE_APP_DB_URI + "/alert-rule",
  //   name: "alert-rule",
  //   meta: { title: "Alert Rule", authRequired: true },
  //   component: () => import("../views/notice/policy/rule/index.vue"),
  // },
  // {
  //   path: process.env.VUE_APP_DB_URI + "/contacts-user",
  //   name: "contacts-user",
  //   meta: { title: "Contacts User", authRequired: true },
  //   component: () => import("../views/notice/contacts/user/index.vue"),
  // },
  // {
  //   path: process.env.VUE_APP_DB_URI + "/contacts-group",
  //   name: "contacts-group",
  //   meta: { title: "Contacts Group", authRequired: true },
  //   component: () => import("../views/notice/contacts/group/index.vue"),
  // },
  {
    path: process.env.VUE_APP_DB_URI + "/alert-template",
    name: "email-template",
    meta: { title: "Email Alert Template", authRequired: true },
    component: () => import("../views/notice/template/index.vue"),
  },

  {
    path: process.env.VUE_APP_DB_URI + "/report",
    name: "report",
    meta: { title: "Report", authRequired: true },
    component: () => import("../views/audit-report/report/settings/index.vue"),
  },
  // {
  //   path: process.env.VUE_APP_DB_URI + "/report-customize",
  //   name: "report",
  //   meta: { title: "Report", authRequired: true },
  //   component: () => import("../views/audit-report/report/customize/index.vue"),
  // },
  {
    path: process.env.VUE_APP_DB_URI + "/report-download",
    name: "report-download",
    meta: { title: "Charts", authRequired: true },
    component: () => import("../views/audit-report/report/fixed/index.vue"),
  },
  // {
  //   path: process.env.VUE_APP_DB_URI + "/chart-report",
  //   name: "charts-push-report",
  //   meta: { title: "Push Report", authRequired: true },
  //   component: () => import("../views/audit-report/report/dynamic/report/index.vue"),
  // },
  // {
  //   path: process.env.VUE_APP_DB_URI + "/chart-device",
  //   name: "charts-devices",
  //   meta: { title: "Device", authRequired: true },
  //   component: () => import("../views/audit-report/report/dynamic/device/index.vue"),
  // },
  {
    path: process.env.VUE_APP_DB_URI + "/audit",
    name: "audit-logs",
    meta: { title: "Audit", authRequired: true },
    component: () => import("../views/audit-report/audit/index.vue"),
  },
  {
    path: process.env.VUE_APP_DB_URI + "/tickets",
    name: "tickets",
    meta: { title: "Tickets", authRequired: true },
    component: () => import("../views/audit-report/ticket/index.vue"),
  },

  {
    path: process.env.VUE_APP_DB_URI + "/user",
    name: "user",
    meta: { title: "User", authRequired: true },
    component: () => import("../views/user-mgmt/user/index.vue"),
  },
  {
    path: process.env.VUE_APP_DB_URI + "/permissions",
    name: "permissions",
    meta: { title: "Roles Permissions", authRequired: true },
    component: () => import("../views/user-mgmt/role/index.vue"),
  },
  {
    path: process.env.VUE_APP_DB_URI + "/onboard-merchants",
    name: "onboard-merchants",
    meta: { title: "On-board Merchants", authRequired: true },
    component: () => import("../views/user-mgmt/onboard-merchants/index.vue"),
  },
  {
    path: process.env.VUE_APP_DB_URI + "/license-settings",
    name: "license-settings",
    meta: { title: "License Settings", authRequired: true },
    component: () => import("../views/license/settings/index.vue"),
  },
  {
    path: process.env.VUE_APP_DB_URI + "/information",
    name: "license-information",
    meta: { title: "License", authRequired: true },
    component: () => import("../views/license/information/index.vue"),
  },
  {
    path: process.env.VUE_APP_DB_URI + "/allocate",
    name: "allocate-authorization",
    meta: { title: "Allocate Authorization", authRequired: true },
    component: () => import("../views/license/allocate/index.vue"),
  },
  {
    path: process.env.VUE_APP_DB_URI + "/accesskeys",
    name: "access-key",
    meta: { title: "Allocate Authorization", authRequired: true },
    component: () => import("../views/accesskeys/index.vue"),
  },
  {
    path: process.env.VUE_APP_DB_URI + "/api-logs",
    name: "api-logs",
    meta: { title: "API Logs", authRequired: true },
    component: () => import("../views/audit-report/api-logs/index.vue"),
  }
];
